// npm
//
import restService from '@/rest/freight/dictionaries'
// import { getMvzItems } from '@/utils/mvzsppUtil'

const state = {
  mvzItems: null,
  sppItems: null,
  agentAgreements: null,
  akAgreements: null,
  organizations: null
}

const mutations = {
  SET_DICTIONARIES: (state, {mvzItems, sppItems, agentAgreements, akAgreements, organizations}) => {
    state.mvzItems = Object.freeze(mvzItems)
    state.sppItems = Object.freeze(sppItems)
    state.agentAgreements = Object.freeze(agentAgreements)
    state.akAgreements = Object.freeze(akAgreements)
    state.organizations = Object.freeze(organizations)
  }
}

const actions = {
  /**
   * initialization on login or reload page
   *
   * @param commit
   * @param state
   * @returns {*|Promise<any>}
   */
  autoinit ({ commit, state }) {
    return actions.loadUpdates({ commit, state })
  },
  autodestroy ({ commit, state }) {
    commit('SET_DICTIONARIES', {})
  },

  /**
   * Get stored ports or load and store
   *
   * @param commit
   * @param state
   * @returns {Promise<any>}
   */
  loadUpdates ({ commit, state }) {
    return new Promise(async (resolve, reject) => {
      if (state.mvzItems == null) {
        let mvzItems = restService.getDictionary('mvz')
        let sppItems = restService.getDictionary('spp')
        let agentAgreements = restService.getDictionary('agent-agreements')
        let akAgreements = restService.getDictionary('ak-agreements')
        let organizations = restService.getDictionary('organizations')
        await Promise.all([mvzItems, sppItems, agentAgreements, akAgreements, organizations]).then(values => {
          mvzItems = values[0]
          sppItems = values[1]
          agentAgreements = values[2]
          akAgreements = values[3]
          organizations = values[4]
        })

        commit('SET_DICTIONARIES', {mvzItems, sppItems, agentAgreements, akAgreements, organizations})
      }
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/mvzspp.js